// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__22egj","buttons":"PendingPaymentAlert_buttons__2z7HN"};